export type PatronReceiptPathParams = {
	outletID: string;
	tableID: string;
	orderID: string;
	menuID: string;
	billID: string;
};

export function buildPatronReceiptPath({
	outletID,
	tableID,
	orderID,
	menuID,
	billID,
}: PatronReceiptPathParams): string {
	return `/menu/patron-app/outlet/${outletID}/table/${tableID}/order/${orderID}/menu-category/${menuID}/summary/confirm-order/payment/${billID}/receipt`;
}

type OrderBill = {
	ID?: string | null;
	businessDate?: string | null;
};

export function getLatestOrderBillId(
	bills?: OrderBill[] | null,
): string | undefined {
	if (!bills?.length) {
		return undefined;
	}

	const sorted = [...bills].sort((a, b) => {
		const aTime = new Date(a.businessDate || 0).getTime();
		const bTime = new Date(b.businessDate || 0).getTime();
		return bTime - aTime;
	});

	return sorted[0]?.ID || undefined;
}
